import React from "react";
import FirstNameInput from "../../../../../../components/inputs/firstName/firstNameInput";
import { CoachListContext } from "../../../context/coachListContext";
import CoachProps from "../../../interface/coachProps";
import EditCoachProps from "../../../interface/editCoachProps";

const RenderFirstNameInput = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
  } = React.useContext(CoachListContext);

  return (
    <FirstNameInput
      required
      firstName={editCoach.coach.vorname}
      setFirstName={(firstName: string) =>
        setEditCoach({
          ...editCoach,
          coach: {
            ...editCoach.coach,
            vorname: firstName,
          },
        })
      }
    />
  );
};

export default RenderFirstNameInput;
